import { Component } from "react";
import { Input, Form, Divider } from "antd";
import { getLangList } from '@/lib/i18n';
import { ReButton } from "@/components/refineElement";
import { modalFromLayout } from "@/lib/antdElementFunction";
import { hasPermission } from "@/lib/permissionUtil";

interface props {
  form?: any;
  groupInfo: any;
  handleType: string;
  clickDelete: any;
}

class ModalGroup extends Component<props> {
  rentT: any = getLangList("rent");
  buttonT: any = getLangList("button");

  componentDidMount() {
    const { form, groupInfo, handleType } = this.props;
    const { groupName } = groupInfo ?? {};

    if (handleType === 'update') {
      form.setFieldsValue({ groupName });
    }
  }

  render() {
    const { form, handleType, clickDelete } = this.props;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
      >
        <Form.Item
          label={this.rentT.CATEGORY}
          name="groupName"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        {handleType === 'update' && hasPermission('RENT_DELETE') &&
          <>
            <Divider dashed />
            <Form.Item label={this.buttonT.DELETE}>
              <ReButton onClick={clickDelete} attributeObject={{ type: "danger" }} iconName='delete' />
            </Form.Item>
          </>
        }
      </Form >
    );
  }
}

export default ModalGroup;